// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3TXBS","title":"Info_title__1-G-L","selects":"Info_selects__nz_1K","requiredAsterisk":"Info_requiredAsterisk__3atFv"};